<template>
	<form ref="recurring_cancel" class="pop-up--form card card--lg" v-on:submit.prevent="submit">
		<div class="card__header">
			<p class="card__title">Stop recurring order</p>
		</div>
		<div class="card__content">
			<div class="alert alert--notice alert--warning">
				<p class="alert__title">If you are stopping your order because you are away for a brief period of time, pause your order instead to keep your time slots secured.</p>
			</div>
		</div>
		<div class="card__content">
			<div class="form__control checkbox">
				<div class="checkbox__item checkbox__item--required">
					<input type="checkbox" name="terms" class="checkbox__control required" id="terms" value="">
					<label for="terms" class="checkbox__label">I confirm that I want to stop my order</label>
				</div>
			</div>
		</div>
		<div class="card__actions">
			<button type="submit" class="button button--md button--error">Stop</button>
		</div>
	</form>
</template>

<script>
    export default {
  		data() {
        return {
        }
      },

      beforeMount() {
    	},

      mounted() {
      },

      methods: {
      	submit(){
      		if(!$(this.$refs.recurring_cancel).valid()) return false;

      		// Order
    			axios.post(`/api/order/recurring/${this.$root.orders.recurring.id}/status`, {
		     		customer_id: this.$root.user.id,
			    	token: this.$root.user.password,
			    	status: 'CANCELED'
		      }).then(res => {
		      	if(res.success === false){

		      	} else {
		      		// Show alert
		      		this.$root.recurringCancel = null;
		      		this.$root.alert = {
		      			type: "SUCCESS",
		      			title: "Stop order",
		      			text: "Your recurring order has been stopped"
		      		};

		      		// Update datas
		      		this.$root.orders.recurring = res.data.datas.recurring;
		      		this.$root.orders.upcoming = res.data.datas.upcoming;
		      		this.$root.next_delivery = res.data.datas.next_delivery;
		      	}
		      }).catch(error => console.log(error));
      	}
    	}
    }
</script>